'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_LANGUAGE_OPTION = [{
  text: 'None',
  value: undefined
}];
function LanguagePreferenceSelect(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "p-x-3",
    children: /*#__PURE__*/_jsx(UIFormControl, {
      "data-test-id": "language-select-form",
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "language-select-label",
          message: `app.card.queue.panel.${props.isPrimary ? 'primaryLanguage' : 'secondaryLanguage'}.label`
        }), props.isPrimary ? /*#__PURE__*/_jsx(UIHelpIcon, {
          className: "p-left-2",
          "data-test-id": "language-select-help",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.card.queue.panel.primaryLanguage.help"
          }),
          tooltipPlacement: "bottom"
        }) : null]
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "language-select",
        onChange: ({
          target: {
            value
          }
        }) => {
          props.onChange(value);
        },
        options: props.isPrimary ? props.languages : EMPTY_LANGUAGE_OPTION.concat(props.languages),
        placeholder: "None",
        value: props.selectedValue
      })
    })
  });
}
LanguagePreferenceSelect.propTypes = {
  languages: PropTypes.array,
  isPrimary: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string
};
export default LanguagePreferenceSelect;